<template>
  <b-card title="Carica dati">

    <b-alert :show="true" variant="warning">
      <strong>CSV:</strong><br>
      Formato nome file: (CODICE CANALE)-(CAMPIONAMENTO).csv<br />
      Esempio:<br />
      <code>ELE001_01-60.csv</code><br />
  <br />
      Separatore: ; (punto e virgola)<br>
      Formato data accettata: <code>DD/MM/YYYY H:m:s</code><br>
      Non utilizzare i nomi delle colonne, inserire i valori a partire dalla prima linea.<br>
      <br>Esempio di riga:<br>
      <code>01/11/2018 3:22:00, 214.763</code>
    </b-alert>

    <b-alert variant="warning" :show="true">
      <p class="mt-3">Codici vettori: <code>EE, gas, olioc, GPL, Diesel, CDR, spll, benz, KJF</code></p>
      <p class="mt-3">Codici campionamento: <code>1, 15, 60, d, m</code></p>
    </b-alert>


    <b-modal id="modalConfirmCsv"
          ref="modal"
          centered
          title="Conferma importazione"
          header-bg-variant="warning"
          ok-title="Procedi"
          ok-variant="warning"
          @ok="goImport">

          <p>Procedere con l'importazione dei dati?</p>
    </b-modal>


    <b-alert variant="danger" :show="warning.length">
      <strong>{{ warning }}</strong>
      {{ warningDetails }}
    </b-alert>

    <b-alert variant="success" :show="complete">Importazione avviata</b-alert>
    <b-list-group>
      <b-list-group-item :variant="file.success ? 'success' : 'default'" v-for="(file) in files" :key="file.id">
        <font-awesome-icon icon="thumbs-up" v-if="file.success" />
        <span>{{file.name}}</span>

        <span v-if="file.error">{{file.error}}</span>
        <span v-else-if="file.success">: caricato</span>
        <span v-else-if="file.active">
          <b-progress class="mb-5" height="20px" variant="primary" :max="100"  show-progress animated>
            <b-progress-bar :value="100">{{file.name}}</b-progress-bar>
          </b-progress>
        </span>
        <span v-else></span>
      </b-list-group-item>
    </b-list-group>
    <file-upload
      v-if="! showPreview"
      ref="uploadEl"
      v-model="files"
      extensions="csv,xlsx"
      post-action="/api/v1/datasheets/upload"
      :headers="headers"
      :multiple="true"
      :size="0"
      @input-file="inputFile"
      @input-filter="inputFilter"
      class="mt-3"
    >

      <b-btn variant="primary">
        <font-awesome-icon icon="cloud-upload-alt" />
        Seleziona
      </b-btn>

    </file-upload>

    <b-btn type="secondary" class="mt-3" v-if="this.files.length && (!$refs.uploadEl || !$refs.uploadEl.active)" @click.prevent="$refs.uploadEl.active = true">
          <i class="fa fa-arrow-up" aria-hidden="true"></i>
          Carica
      </b-btn>


    <div v-if="showPreview">
      <h3 class="mb-3">Anteprima dati</h3>
      <b-list-group class="mb-3" v-for="(response, i) in responses" :key="i">

          <b-list-group-item :variant="itemStatus(item)" v-for="item in response.channels" v-bind:key="item.code">
            <strong>{{ item.code }}</strong>
            <span v-if="item.name">({{ item.name }})</span> {{ response.intervalName }}</b-list-group-item>

      </b-list-group>

      <b-btn variant="success" v-b-modal.modalConfirmCsv>Avvia importazione</b-btn>
    </div>
  </b-card>
</template>

<script>
import FileUpload from 'vue-upload-component'

var VueCookie = require('vue-cookie')

export default {
  name: "uploadEl",
  components: { FileUpload },
  data() {
    return {
      showPreview: false,
      files: [],
      channels: [],
      interval: null,
      complete: false,
      warning: "",
      warningDetails: "",
      channels: [],
      datasheetId: 0,
      loaded: 0,
      responses: []
    }
  },
  computed: {
    headers() {
      return {
        Authorization: VueCookie.get("token")
      }
    },
  },
  methods: {

    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        if (! /(\.csv|\.xlsx)$/i.test(newFile.name)) {
          this.warning = "Selezionare file in formato CSV o XLSX";
          return prevent()
        }
      }
    },
    inputFile(newFile, oldFile) {
      if (newFile && !oldFile) {
        // add
      }
      if (newFile && oldFile) {
        // update
        if(!newFile.active && oldFile.active) {
          if(++this.loaded == this.files.length) {
            this.showPreview = true
          }
          let data = _.clone(newFile.response.data)
          this.responses.push({
            interval: data.interval,
            intervalName: data.intervalName,
            channels: data.channels,
            datasheetId: data.id,
          })
        }
      }
      if (!newFile && oldFile) {
        // remove
        console.log('remove', oldFile)
      }
    },
    goImport() {
      this.$store.commit("loading")

      this.responses.forEach(r => {
        this.$store.dispatch("datasheets/import", r.datasheetId).then( (data) => {
          this.$store.commit("stopLoading")
          this.showPreview = false
          this.complete = true
        })
      })
    },
    itemStatus(item) {
      if(item.status == 1)
        return 'info'

      if(item.status == 0)
        return 'warning'

      if(item.status == -1)
        return 'alert'
    },
  }
}
</script>

<style>
.file-uploads {
  vertical-align: top;
}
code {
  color: white;
  padding: 2px 4px;
  background-color:darkslategray;
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/Import/MultiUpload.vue